export const checkIsMobile = () => {
  return window.innerWidth < 576;
};

export const isMyAccountVerified = (user) => {
  if (
    user?.phoneStatus === "Verified" &&
    user?.emailStatus === "Verified" &&
    user?.firstName !== "" &&
    user?.lastName !== "" &&
    user?.gender !== "" &&
    user?.nationality !== ""
  ) {
    return true;
  }
  return false;
};
